module.exports = __webpack_public_path__ + "operace-nosu_9_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_9_before.jpg
// module id = 1144
// module chunks = 0